import { render, staticRenderFns } from "./QueriesSidebar.vue?vue&type=template&id=00a94a3c"
import script from "./QueriesSidebar.vue?vue&type=script&lang=js"
export * from "./QueriesSidebar.vue?vue&type=script&lang=js"
import style0 from "./QueriesSidebar.vue?vue&type=style&index=0&id=00a94a3c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports